function init_communication() {

    $('button[name=btn-creer-communication]').off("click").on("click", function (a) {
        editer_communication(a, null, null);
    });

}

init_communication();

function initUniteEvaluationSelect2(container) {
    var paramsSupp = {};

    var champs = container.find('[name="uniteEvaluation"]');
    var callbackParamsSupp = function () {
        return {
            id_municipalite: container.find('[name=municipalite]').val()
            //date_evenement: $('#date-evenement').val()
        };
    };
    $.each(champs, function (index, champ) {
        initSelecteurDeRecherche($(champ), "/gestion-roles/get-choix-unite-evaluation", true, false, false, paramsSupp, callbackParamsSupp);
    });
}

function getEvenementSelect2Params(input) {
    var container = $('#modal_communication');
    var dateEvenement = moment().format('YYYY-MM-DD');

    return {
        id_ue: container.find('[name=uniteEvaluation]').val(),
        date_evenement: dateEvenement,
        garder_id: true
    };
}


function editer_communication(a, id, object) {

    var params = {};
    if (id) {
        params.id = id;
    }

    var estExplorateur = ($('#collapse-communication').length > 0);
    if (estExplorateur) {
        params.id_municipalite = $('#exp-ue-liste-ville').val();
        params.id_ue = $('#exp-ue-body-information').find('#id-ue').text();
    }

    var titreCOmmunicationUE = $(a.target).closest('tr').find('a.comm-ligne-champ-ue').text();
    var titreCommunication = 'Éditer la communication pour ' + titreCOmmunicationUE;
    var titre = titreCommunication;
    if (!id) {
        titre = 'Nouvelle communication';
    } else if (titreCOmmunicationUE.length === 0) {
        titre = 'Éditer la communication';
    }

    // modal.find('.modal-header h4').html(titre);

    var editionCommunication = {
        id: "modal_communication",
        view: "/core/modal/",
        processus_id: "",
        titre: titre,
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/communication/editer/",
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "tres-grande",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                title: "",
                classSupp: "",
                afficher: true
            },

            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: true,
                id: "btnSauvegardeCommunication",
                disabled: false
            }
        ]
    };
    setTimeout(function () {
        var callbacks = [function () {
            callbackEditerCommunication(id, object, params);
        }];
        // TODO: Valider les autorisations et afficher un message correspondant

        fenetreModal.creerModal(editionCommunication, params, callbacks);
    }, 0);
}


function callbackEditerCommunication(id, object, params) {
    var modal = $('#modal_communication');
    var options = {blocsContainer: modal};

    modal.find('[name="proprietaire"]').data('callback-params-supp', getProprietaireSelect2Params);
    modal.find('[name="evenement"]').data('callback-params-supp', getEvenementSelect2Params);
    modal.find('[name=municipalite]').select2().on('change', function (e) {
        $.get('/gestion-roles/communication/organisation/', {'municipalite': e.val}, (data) => {
            if (data.length > 0) {
                $('#form-partager_entre_org').closest('.form-group').show();
                var element = $('#form-partager_entre_org').closest('.form-group').find('.control-label');
                element.text("Partager entre organisations: " + ' ' + data.join(', '));
            }else {
                $('#form-partager_entre_org').closest('.form-group').hide();
            }

        });
    });

    controlesFormulaires.redimentionnerTextarea();
    initUniteEvaluationSelect2(modal);
    initSelect2(modal);
    initBlocsCharges(null, null, options);

    masquesSelection.init();

    // Si une municipalité ou une UE sont sélectionnées, on les sélectionne ici
    if ('id_municipalite' in params) {
        $("#form-municipalite").select2("val", params.id_municipalite);
    }

    if ('id_ue' in params && params.id_ue) {
        wait.start();
        $('#form-uniteEvaluation').select2("search", params.id_ue);

        setTimeout(function () {
            if ($('#select2-drop').find('li').length === 1) {
                $('#select2-drop .select2-result.select2-highlighted').trigger('mouseup');
            }
            wait.stop();
        }, 1000);
    }

    $('#btnSauvegardeCommunication').off('click').on('click', function (e) {
        var dateCommunication = $('#communication [name=date_debut]').val();
        $('#document-communication-sous-bloc .sous-bloc-form').find('[name=date_debut]').val(dateCommunication + ' 00:00:00');
        let ueEstSaisie = $('#communication [name="uniteEvaluation"]').select2('val') !== '';

        var options = {
            modeSave: ModeSave.MENU,
            blocsContainer: modal,
            paramsSupp: {sauvegarde_complet: true}
        };

        var callback = function (response) {
            if (response.reponse == 'ok') {
                if (response.avertissements == undefined) {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie',
                        messageDuree: 500,
                        icone: 'fa-check-circle-o',
                        iconeCouleur: 'green'
                    });
                } else {
                    infos.ajouterMessageToast({
                        message: 'Sauvegarde réussie avec avertissement(s): ' + response.avertissements,
                        messageDuree: 0,
                        icone: 'fa-exclamation-triangle',
                        iconeCouleur: 'orange'
                    });
                }

                modal.modal('hide');
                refreshDatatables();
            } else { // Si on aboutit ici, c'est une erreur de sauvegarde des documents en raison d'une validation sur un champ requis non complété
                infos.ajouterMessageToast({
                    message: "Erreur de sauvegarde : une valeur requise est manquante",
                    messageCouleur: "red",
                    messageDuree: 0,
                    type: 'error'
                });
            }
        };

        if (!ueEstSaisie) {
            fenetreModal.modalMessage({
                titre: "L'unité d'évaluation n'a pas été saisie. Voulez-vous continuer?",
                sansX: true,
                texteExplicatif: "",
                boutons: {
                    "Oui": {
                        label: " Oui ",
                        id: "",
                        class: "btn btn-success",
                        action: function () {
                            fenetreModal.fermerModalAlerteDivs();
                            setTimeout(function () {
                                saveBlocs(false, callback, options);
                            }, 0);
                        }
                    },
                    "Non": {
                        label: " Non ",
                        id: "",
                        class: "btn",
                        action: function () {
                            fenetreModal.fermerModalAlerteDivs();
                        }
                    }
                }
            });
        }
        else {
            saveBlocs(false, callback, options);
        }
    });

    var inputMunicipalite = modal.find('[name=municipalite]');
    inputMunicipalite.on('change', function () {
        afficherSelonMun();
    });
}

function supprimer_communication(id, object) {
    fenetreModal.modalMessage({
        titre: "Êtes-vous certain de vouloir supprimer l'unité d'évaluation (" + $('#wizard').attr('id-ue') + ") en cours sera annulée, êtes-vous certain ?",
        sansX: true,
        texteExplicatif: "",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                }
            }
        }
    });
}

function getProprietaireSelect2Params(input) {
    var container = $('#modal_communication');
    var dateEvenement = moment().format('YYYY-MM-DD');

    return {
        id_ue: container.find('[name=uniteEvaluation]').val(),
        date_evenement: dateEvenement,
        garder_id: true,
        ue_null_skip: true
    };
}

function afficherSelonMun() {
    //var boolGeocentralis = $('[name=bool_geocentralis]').val();
    var modal = $('#modal_communication');
    var municipalitesGeocentralis = JSON.parse(modal.find('[name=municipalites-geocentralis-json]').val());
    var municipaliteInput = modal.find('[name=municipalite]');

    var boolGeocentralis = municipalitesGeocentralis[municipaliteInput.val()];

    var afficherGeo = (boolGeocentralis == true); //(boolGeocentralis == 'True' || boolGeocentralis == 'true');
    var afficherNonGeo = (boolGeocentralis == false); // (boolGeocentralis == 'False' || boolGeocentralis == 'false');

    modal.find('[name=uniteEvaluation]').closest('div.ctrl2').toggle(!afficherNonGeo);
    modal.find('[name=unite_evaluation]').closest('div.ctrl2').toggle(afficherNonGeo);

    modal.find('[name=uniteEvaluation],[name=evenement],[name=proprietaire]').prop('disabled', !afficherGeo);
}

function communicationUeClicked(object) {
    var row = $(object).closest('tr');
    var id = row.attr('id');
    var idUe = row.attr('data-id_ue');
    var idMunicipalite = row.attr('data-id_municipalite');
    var matricule = row.attr('data-matricule');
    communicationOuvrirExplorateurUe(id, idUe, idMunicipalite, matricule);
    return false;
}


function communicationOuvrirExplorateurUe(id, idUe, idMunicipalite, matricule) {
    var params = {'id_module': 31, 'id': id, 'idUe': idUe, 'idMunicipalite': idMunicipalite, 'matricule': matricule};
    var ouvrirExplorateurUE = {
        id: "modal-explorateur-ue",
        view: "/core/modal/",
        processus_id: "",
        titre: "Explorateur UE",
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: "/gestion-roles/explorateur-ue/",
        template_depart: "",
        sans_x: false,
        template_depart_view: "",
        url: "",
        taille: "immense",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Fermer",
                title: "",
                classSupp: "",
                afficher: true
            }
        ]
    };
    var callbacks = [function () {
        var date_initiale = moment().format('YYYY-MM-DD') + ' 23:59:59';

        init_explorateur_ue_1();
        init_explorateur_ue_2(idMunicipalite, date_initiale);

        expUeChargerUe(date_initiale, null, idMunicipalite, matricule);

        fenetreModal.calculerHauteurModal($('#modal-explorateur-ue'), '#contenu');
        $('#div-resultat-historique').html('');
        $('#exp-ue-information').removeClass('col-xs-10');
        $('#exp-ue-historique').removeClass('col-xs-2');
        $('#exp-ue-information').addClass('col-xs-12');
    }];
    fenetreModal.creerModal(ouvrirExplorateurUE, params, callbacks);
}
